import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]


export default /*@__PURE__*/_defineComponent({
  __name: 'IntegerInput',
  props: {
    modelValue: {},
    min: {},
    max: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const validateKey = (e: KeyboardEvent) => {
  const re = /\d/;
  // Prevent input if it's a regular letter which is not a number,
  // but also prevent input if we reached max number value.
  // FIXME: won't work for negative values
  if (e.key.length == 1 && (!re.test(e.key) || props.modelValue == props.max)) {
    e.preventDefault();
  }
};

const newValue = (value: string) => {
  const num = value == "" ? 0 : Number(value);
  if (isNaN(num)) {
    return;
  }
  const min = props.min ?? Number.NEGATIVE_INFINITY;
  const max = props.max ?? Number.POSITIVE_INFINITY;
  const int = Math.max(min, Math.min(max, Math.round(num)));
  emit("update:modelValue", int);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "text",
    inputmode: "numeric",
    pattern: "\\d*",
    onKeydown: validateKey,
    value: _ctx.modelValue,
    onInput: _cache[0] || (_cache[0] = (e) => newValue(e.target?.value)),
    class: "input input-bordered"
  }, null, 40, _hoisted_1))
}
}

})